<template>
  <div
    class="wrapper"
    :class="[
      { 'nav-open': $sidebar.showSidebar },
      { rtl: $route.meta.rtlActive }
    ]"
  >
    <notifications></notifications>
    <side-bar
      :active-color="sidebarBackground"
      :data-background-color="sidebarBackgroundColor"
    >
      <!-- <user-menu></user-menu> -->
      <!-- <mobile-menu></mobile-menu> -->
      <template slot="links">
        <sidebar-item :link="{ name: 'Partidos', icon: 'sports_soccer' }">
          <sidebar-item
            :link="{ name: 'Listado', icon: 'sports_soccer', path: '/list/games' }"
          ></sidebar-item>
          <sidebar-item
            v-if="isAdmin"
            :link="{ name: 'Crear', icon: 'sports_soccer', path: '/game/create' }"
          ></sidebar-item>
        </sidebar-item>

        <sidebar-item :link="{ name: 'Editorial', icon: 'sports' }" v-if="isAdmin">
          <sidebar-item
            :link="{ name: 'Listado', icon: 'sports', path: '/list/editorial' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Crear', icon: 'sports', path: '/editorial/create' }"
          ></sidebar-item>
        </sidebar-item>

        <sidebar-item :link="{ name: 'Ticketera', icon: 'local_activity' }" v-if="isAdmin">
          <sidebar-item
            :link="{ name: 'Listado', icon: 'local_activity', path: '/list/ticketera' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Crear', icon: 'local_activity', path: '/ticketera/create' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Estadisticas', icon: 'local_activity', path: '/ticketera/statistics' }"
          ></sidebar-item>
        </sidebar-item>

        <sidebar-item :link="{ name: 'Encuestas', icon: 'help_outline' }" v-if="isAdmin">
          <sidebar-item :link="{ name: 'Listado', icon: 'help_outline', path: '/list/survey' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Crear', icon: 'help_outline', path: '/survey/create' }"></sidebar-item>
        </sidebar-item>

        <sidebar-item :link="{ name: 'Publicidad', icon: 'campaign' }" v-if="isAdmin">
          <sidebar-item :link="{ name: 'Listado', icon: 'campaign', path: '/list/advertising' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Crear', icon: 'campaign', path: '/advertising/create' }"></sidebar-item>
        </sidebar-item>

        <sidebar-item :link="{ name: 'Usuarios', icon: 'face' }" v-if="isAdmin">
          <sidebar-item
            :link="{ name: 'Listado', path: '/list/users' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Crear', path: '/user/create' }"
          ></sidebar-item>
        </sidebar-item>

        <sidebar-item :link="{ name: 'Equipos', icon: 'groups' }" v-if="isAdmin">
          <sidebar-item
            :link="{ name: 'Listado', path: '/list/teams' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Crear', path: '/teams/create' }"
          ></sidebar-item>
        </sidebar-item>

        <sidebar-item :link="{ name: 'Estadios', icon: 'domain' }" v-if="isAdmin">
          <sidebar-item
            :link="{ name: 'Listado', path: '/list/stadiums' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Crear', path: '/stadiums/create' }"
          ></sidebar-item>
        </sidebar-item> 

        <sidebar-item :link="{ name: 'Temporada', icon: 'emoji_events' }" v-if="isAdmin">
          <sidebar-item
            :link="{ name: 'Listado', path: '/list/season' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Crear', path: '/season/create' }"
          ></sidebar-item>
        </sidebar-item>

        <sidebar-item :link="{ name: 'Configuración', icon: 'sort' }" v-if="isAdmin">
          <sidebar-item
            :link="{ name: 'Tutorial', path: '/tutorial' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Banner', path: '/banner' }"
          ></sidebar-item>
        </sidebar-item>

        <sidebar-item class="qtyUserRegister" :link="{ name: `Usuarios registrados: ${qtyUserRegister}`, icon: 'people_outline', path:`${$route.path}`}" v-if="isAdmin"> 
        </sidebar-item> 
      </template>
    </side-bar>
    <div class="main-panel" id="main-panel">
      <top-navbar></top-navbar>

      <!-- <fixed-plugin
        :color.sync="sidebarBackground"
        :colorBg.sync="sidebarBackgroundColor"
        :sidebarMini.sync="sidebarMini"
        :sidebarImg.sync="sidebarImg"
        :image.sync="sidebarBackgroundImage"
      >
      </fixed-plugin> -->

      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <!-- <content-footer v-if="!$route.meta.hideFooter"></content-footer> -->
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import TopNavbar from "./TopNavbar.vue";
// import ContentFooter from "./ContentFooter.vue";
// import MobileMenu from "./Extra/MobileMenu.vue";
// import FixedPlugin from "../../FixedPlugin.vue";
// import UserMenu from "./Extra/UserMenu.vue";
import { ZoomCenterTransition } from "vue2-transitions";
import persistentData from "@/plugins/persistentData";

export default {
  components: {
    TopNavbar,
    ZoomCenterTransition
  },
  data() {
    return {
      sidebarBackgroundColor: "black",
      sidebarBackground: "azure",
      sidebarMini: false,
      sidebarImg: false,
      isAdmin: false,
      isShowController: false,
      qtyUserRegister: 0
    };
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(true);
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    }
  },
  async mounted() {
    let docClasses = document.body.classList;
    let isWindows = navigator.platform.startsWith("Win");
    if (isWindows) {
      // if we are on windows OS we activate the perfectScrollbar function
      initScrollbar("sidebar");
      initScrollbar("sidebar-wrapper");
      initScrollbar("main-panel");

      docClasses.add("perfect-scrollbar-on");
    } else {
      docClasses.add("perfect-scrollbar-off");
    }

    this.isAdmin = persistentData.getData('admin', true)
    this.isShowController = persistentData.getData('showController', true)
    const request = await this.$store.dispatch("getAppUsersQty")
    if (request.status == 200) this.qtyUserRegister = request.data
  },
  watch: {
    sidebarMini() {
      this.minimizeSidebar();
    },
    $route() {
      document.getElementById("main-panel").scrollTo(0,0)
    }
  }
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}

.qtyUserRegister {
  padding-top: 80px;

  a {
    border: 1px solid white;
    display: flex;

    &:hover, &.active {
      background: none;
      background: none !important;
      box-shadow: none !important;
    }
  }
}
</style>
